export function mergeRelatedFields(data: Record<string, any>): Record<string, any> {
  const relatedFields: Record<string, any> = {};
  const result: Record<string, any> = {};

  for (const [key, value] of Object.entries(data)) {
    if (key.startsWith('related.')) {
      const relatedKey = key.replace('related.', '');
      relatedFields[relatedKey] = value;
    } else {
      result[key] = value;
    }
  }

  const existingRelated =
    result.related && typeof result.related === 'object' ? result.related : {};

  result.related = {
    ...relatedFields,
    ...existingRelated,
  };

  return result;
}
